import React, { useEffect } from 'react'
import {
    RFPContext,
    VendorProjectContext,
    WorkorderContext,
    useRFPState,
    useVendorProjectState,
    useWorkorderState,
} from '../../contexts'
import { EZWorkHome } from './EZWorkHome'
import { useAppDispatch } from '../../hooks'
import { getUserList } from '../../store/user/action'

export const EZWorkRoot = () => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(getUserList({ params: { my_team: true } })).catch(() => {})
    }, [dispatch])

    const workorderState = useWorkorderState()
    const rfpState = useRFPState()
    const vendorProjectState = useVendorProjectState()

    return (
        <WorkorderContext.Provider value={workorderState}>
            <RFPContext.Provider value={rfpState}>
                <VendorProjectContext.Provider value={vendorProjectState}>
                    <EZWorkHome />
                </VendorProjectContext.Provider>
            </RFPContext.Provider>
        </WorkorderContext.Provider>
    )
}
